import React from 'react'
import { useSelector } from 'react-redux'

import { getMultipleOrgsSelected } from '@/utils/helpers'

import Widget from '../../../components/widget/Widget'
import { ItemsByDateWidget } from '../widgets/ItemsByDateWidget'
import { ItemsByUserWidget } from '../widgets/ItemsByUserWidget'
import { ItemUsageWidget } from '../widgets/ItemUsageWidget'
import { ItemsByCallWidget } from '../widgets/ItemsByCallWidget'
import { BaseItemsByOrganizationWidget } from '../widgets/BaseItemsByOrganizationWidget'

export const PostCallSection = () => {
  const { hierarchy_manager: isHierarchyManager, own_organization_id } = useSelector(
    (state) => state.currentUser
  )
  const isBaltoAdmin = own_organization_id === 1
  const { filters } = useSelector((state) => state.analytics)
  const { flattenedUserOrgHierarchy } = useSelector((state) => state.orgHierarchy)
  // None selected is treated as multiple — shows org-level widgets, disables single-org features
  const multipleOrgsSelected = getMultipleOrgsSelected({
    isBaltoAdmin,
    isHierarchyManager,
    flattenedUserOrgHierarchy,
    organizations: filters.organizations,
  })

  return (
    <div data-testid="reports-postcall">
      <Widget
        widgetId="postcall-usage"
        label="Post Call Usage"
        subtitle="The count of each post call item trigger across selected agents"
        subtitlePercent="Average trigger rate of each post call item across selected agents"
        showPercent
        showViewToggle
        showCsvDownload
      >
        <ItemUsageWidget section="postcall" />
      </Widget>
      <Widget
        widgetId="postcall-usageByDate"
        label="Post Call Frequency by Date"
        subtitle="Time series of the count of each post call item trigger across selected agents"
        subtitlePercent="Time series of average trigger rate of each post call item across selected agents"
        showGroupBy
        showPercent
        showViewToggle
        showCsvDownload
      >
        <ItemsByDateWidget section="postcall" />
      </Widget>
      {multipleOrgsSelected ? (
        <Widget
          widgetId="postcall-usageByOrganization"
          label="Post Call Frequency by Organization"
          subtitle="The count of each post call item trigger for each selected organization"
          subtitlePercent="Average trigger rate of each post call item for each selected organization"
          showPercent
          showViewToggle
          showCsvDownload
          percentViewDefault={false}
        >
          <BaseItemsByOrganizationWidget section="postcall" loadingKey="postcallPage" />
        </Widget>
      ) : (
        <Widget
          widgetId="postcall-usageByUser"
          label="Post Call Frequency by User"
          subtitle="The count of each post call item trigger for each selected agents"
          subtitlePercent="Average trigger rate of each post call item for each selected agents"
          showPercent
          showViewToggle
          showCsvDownload
          percentViewDefault={false}
        >
          <ItemsByUserWidget section="postcall" />
        </Widget>
      )}
      <Widget
        widgetId="postcall-wins"
        label="Post Call Wins"
        subtitle="The count of won calls of each post call item across selected agents"
        subtitlePercent="Average win rate of each post call item across selected agents"
        showPercent
        showViewToggle
        showCsvDownload
      >
        <ItemUsageWidget section="postcall" isWin />
      </Widget>
      {!multipleOrgsSelected && (
        <Widget
          widgetId="postcall-usageByCall"
          label="Post Call Usage By Call"
          subtitle="Matrix table of calls, where each row represents a call and each column is a post call item, with colored cells indicating usage"
        >
          <ItemsByCallWidget section="postcall" />
        </Widget>
      )}
    </div>
  )
}
